/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  listConversations(agentId, { filter } = {}) {
    return axios.get(`${this.url}/${agentId}/conversations`, {
      params: { filter },
    });
  }
}

export default new Agents();
